module.exports = __webpack_public_path__ + "img/iosevka-light.0bb90e5c.png";